module.exports = __webpack_public_path__ + "img/trustly.4855a211.svg";